import { render, staticRenderFns } from "./CostBudget.vue?vue&type=template&id=7c674f66"
import script from "./CostBudget.vue?vue&type=script&setup=true&lang=js"
export * from "./CostBudget.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports